/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Which tenancy tier owns the match: project-specific, organization-level, or platform-level.
 */
export const Tier = {
  ProjectSpecific: "project-specific",
  OrganizationLevel: "organization-level",
  PlatformLevel: "platform-level",
} as const;
/**
 * Which tenancy tier owns the match: project-specific, organization-level, or platform-level.
 */
export type Tier = ClosedEnum<typeof Tier>;

/**
 * An existing remote_session_issuer that already describes the upstream authorization server a caller is about to add.
 */
export type RemoteSessionIssuerDuplicateMatch = {
  /**
   * The matching remote_session_issuer id.
   */
  id: string;
  /**
   * The matching issuer's stored upstream URL. May differ in spelling from the URL that was looked up, since canonicalization is applied to the supplied URL only.
   */
  issuer: string;
  /**
   * The matching issuer's display name. Empty when it has none, in which case a caller should fall back to the slug.
   */
  name: string;
  /**
   * The owning project's name, for a project-specific match an organization administrator may not otherwise be able to place. Empty for organization-level and platform-level matches, and for project-specific matches returned to a caller already scoped to that project.
   */
  projectName: string;
  /**
   * The matching issuer's slug.
   */
  slug: string;
  /**
   * Which tenancy tier owns the match: project-specific, organization-level, or platform-level.
   */
  tier: Tier;
};

/** @internal */
export const Tier$inboundSchema: z.ZodMiniEnum<typeof Tier> = z.enum(Tier);

/** @internal */
export const RemoteSessionIssuerDuplicateMatch$inboundSchema: z.ZodMiniType<
  RemoteSessionIssuerDuplicateMatch,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    issuer: z.string(),
    name: z.string(),
    project_name: z.string(),
    slug: z.string(),
    tier: Tier$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "project_name": "projectName",
    });
  }),
);

export function remoteSessionIssuerDuplicateMatchFromJSON(
  jsonString: string,
): SafeParseResult<RemoteSessionIssuerDuplicateMatch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RemoteSessionIssuerDuplicateMatch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RemoteSessionIssuerDuplicateMatch' from JSON`,
  );
}
